"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconCaretRight = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M21.6 12.51a3.85 3.85 0 0 0 0 5.44l17 17-17 17a3.85 3.85 0 0 0 0 5.45 3.85 3.85 0 0 0 5.45 0L49.54 35 27.06 12.5a3.85 3.85 0 0 0-5.46.01z"
  })),
  height: undefined,
  width: undefined
});
IconCaretRight.displayName = 'IconCaretRight';
var _default = IconCaretRight;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/caret-right.js
// module id = 551
// module chunks = 0